/**
 * IndStartups footer — editorial, matches aisarva landing tone.
 * Reaffirms the "Powered by AI Sarva" attribution explicitly so users
 * always know this app is part of the aisarva family.
 */
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/5 bg-plum-950/60 backdrop-blur-sm mt-20">
      <div className="max-w-7xl mx-auto px-5 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <a href="https://aisarva.com" className="inline-flex items-center gap-3 group">
            <img
              src="/brand/aisarva-icon-white.png"
              alt=""
              aria-hidden
              className="w-9 h-9 object-contain opacity-90 group-hover:opacity-100 transition"
            />
            <div className="flex flex-col">
              <span className="text-[10px] font-mono uppercase tracking-[0.35em] text-amber-300/80">
                powered by
              </span>
              <span className="font-display text-xl font-semibold text-cream-50 tracking-tight">
                AI Sarva
              </span>
            </div>
          </a>
          <p className="mt-5 text-sm text-cream-100/60 leading-relaxed max-w-md">
            IndStartups is part of the <a href="https://aisarva.com" className="text-amber-300 hover:underline">aisarva.com</a> family —
            an editorial catalogue for founders, builders and the curious. Hand-curated,
            free, never affiliated with any government agency.
          </p>
        </div>

        <div>
          <h3 className="text-[10px] uppercase tracking-[0.3em] text-amber-300/80 font-mono mb-4">
            On this page
          </h3>
          <ul className="space-y-2 text-sm text-cream-100/70">
            <li><a href="#journey" className="hover:text-amber-300 transition">Founder journeys</a></li>
            <li><a href="#path"    className="hover:text-amber-300 transition">Path finder</a></li>
            <li><a href="#map"     className="hover:text-amber-300 transition">Ecosystem map</a></li>
            <li><a href="#browse"  className="hover:text-amber-300 transition">All schemes</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-[10px] uppercase tracking-[0.3em] text-amber-300/80 font-mono mb-4">
            More from aisarva
          </h3>
          <ul className="space-y-2 text-sm text-cream-100/70">
            <li><a href="https://aisarva.com/tools"    target="_blank" rel="noopener" className="hover:text-amber-300 transition">AI tools directory</a></li>
            <li><a href="https://aisarva.com/oss"      target="_blank" rel="noopener" className="hover:text-amber-300 transition">Open source</a></li>
            <li><a href="https://aisarva.com/projects" target="_blank" rel="noopener" className="hover:text-amber-300 transition">Project teardowns</a></li>
            <li><a href="https://aisarva.com/blog"     target="_blank" rel="noopener" className="hover:text-amber-300 transition">Essays</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 py-5 text-[11px] font-mono uppercase tracking-[0.25em] text-cream-100/40 text-center">
          © {year} AI Sarva · Built with public data
        </div>
      </div>
    </footer>
  );
}
